var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFilledAddressCard24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Patient Activity &amp Status") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/address-card_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "\\uD83C\\uDF08-Icon-Color"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 6.000000)",
    id: "address-card",
    fill: "#999D9F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.6666667,0 L1.33333333,0 C0.597222222,0 0,0.597222222 0,1.33333333 L0,11.1111111 C0,11.8472222 0.597222222,12.4444444 1.33333333,12.4444444 L14.6666667,12.4444444 C15.4027778,12.4444444 16,11.8472222 16,11.1111111 L16,1.33333333 C16,0.597222222 15.4027778,0 14.6666667,0 Z M4.88888889,2.66666667 C5.86944444,2.66666667 6.66666667,3.46388889 6.66666667,4.44444444 C6.66666667,5.425 5.86944444,6.22222222 4.88888889,6.22222222 C3.90833333,6.22222222 3.11111111,5.425 3.11111111,4.44444444 C3.11111111,3.46388889 3.90833333,2.66666667 4.88888889,2.66666667 Z M8,9.24444444 C8,9.53888889 7.72222222,9.77777778 7.37777778,9.77777778 L2.4,9.77777778 C2.05555556,9.77777778 1.77777778,9.53888889 1.77777778,9.24444444 L1.77777778,8.71111111 C1.77777778,7.82777778 2.61388889,7.11111111 3.64444444,7.11111111 L3.78333333,7.11111111 C4.125,7.25277778 4.49722222,7.33333333 4.88888889,7.33333333 C5.28055556,7.33333333 5.65555556,7.25277778 5.99444444,7.11111111 L6.13333333,7.11111111 C7.16388889,7.11111111 8,7.82777778 8,8.71111111 L8,9.24444444 Z M14.2222222,7.77777778 C14.2222222,7.9 14.1222222,8 14,8 L10,8 C9.87777778,8 9.77777778,7.9 9.77777778,7.77777778 L9.77777778,7.33333333 C9.77777778,7.21111111 9.87777778,7.11111111 10,7.11111111 L14,7.11111111 C14.1222222,7.11111111 14.2222222,7.21111111 14.2222222,7.33333333 L14.2222222,7.77777778 Z M14.2222222,6 C14.2222222,6.12222222 14.1222222,6.22222222 14,6.22222222 L10,6.22222222 C9.87777778,6.22222222 9.77777778,6.12222222 9.77777778,6 L9.77777778,5.55555556 C9.77777778,5.43333333 9.87777778,5.33333333 10,5.33333333 L14,5.33333333 C14.1222222,5.33333333 14.2222222,5.43333333 14.2222222,5.55555556 L14.2222222,6 Z M14.2222222,4.22222222 C14.2222222,4.34444444 14.1222222,4.44444444 14,4.44444444 L10,4.44444444 C9.87777778,4.44444444 9.77777778,4.34444444 9.77777778,4.22222222 L9.77777778,3.77777778 C9.77777778,3.65555556 9.87777778,3.55555556 10,3.55555556 L14,3.55555556 C14.1222222,3.55555556 14.2222222,3.65555556 14.2222222,3.77777778 L14.2222222,4.22222222 Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilledAddressCard24Px);
export default __webpack_public_path__ + "static/media/Icons_Filled_address-card_24px.f9ff330f.svg";
export { ForwardRef as ReactComponent };